module.exports = __webpack_public_path__ + "cf77b6f6645c1f55caefe83dc1c1eefa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/src/js/images/logo.png
// module id = 1104
// module chunks = 0